import { calendarDaysBetween } from '../../calendarDays';

/** Past this, the contact is too stale to be worth a seller's attention. */
const STALE_AFTER_DAYS = 28;

const plural = (count: number, unit: string) =>
  `${count} ${unit}${count === 1 ? '' : 's'} ago`;

/**
 * Copy for the profile modal's contact row, or null when there is nothing worth
 * showing — no contact on record, an unparseable date, a date after today, or a
 * contact at least four weeks old. Callers hide the row on null rather than
 * render a placeholder.
 *
 * Counts are in calendar days, so a contact late yesterday reads "1 day ago"
 * however few hours have elapsed.
 */
export const formatLastContacted = (
  lastContacted: string | null,
): string | null => {
  if (lastContacted === null) return null;

  const contactedAt = new Date(lastContacted);
  if (Number.isNaN(contactedAt.getTime())) return null;

  const days = calendarDaysBetween(contactedAt, new Date());

  // A contact dated after today is a data or clock fault. The row asserts what
  // the seller's own team did, so say nothing rather than round it to "Today".
  if (days < 0) return null;
  if (days >= STALE_AFTER_DAYS) return null;
  if (days === 0) return 'Today';
  if (days < 7) return plural(days, 'day');

  return plural(Math.floor(days / 7), 'week');
};
